import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ObjectNames, Severity, Status } from 'src/app/inventory/constants/constants';
import { LocationsService } from 'src/app/inventory/locations/locations.service';
import { SubscriptionFeatureLimitM } from '../../models/organization-subscription/subscription-feature-limit.modal';
import { MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { AppMainComponent } from 'src/app/app.main.component';
import { OrganizationSubscriptionService } from '../../services/organization-subscription.service';
import { FeatureSubscriptionInfoEnums } from '../../enums/feature-subscription-info.enum';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { addInList } from '../../helpers';

@Component({
  selector: 'app-location-view-edit',
  templateUrl: './location-view-edit.component.html',
  styleUrls: ['./location-view-edit.component.scss']
})
export class LocationViewEditComponent implements OnInit {
  locationForm: FormGroup;
  @Output() closeLocationView = new EventEmitter<boolean>();
  @Input() location: any ;
  @Input() displaylocationView: boolean = false;
  displayWarehouseView: boolean = false;
  displayAddNewOption: boolean = false;
  isAddLocation: boolean = true;
  loadingSpinner: boolean = false;


  display: boolean = false;
  header = '';
  subscriptionLimit: SubscriptionFeatureLimitM = null;
  allLocations = [];

  statusDisabled: boolean = false;
  types = [];
  group;
  categoryGroup;
  groups = [];
  category = [];
  allContactsDD =[];
  inventoryGroups = [];
  states = [];
  selectedStates;
  city = [];
  selectedCity;
  addressTypes = [];
  country = [];
  selectedCountry;
  ErrorMessageSetLocation = '';
  formattedAddress;
  addressInput = "";
  streetAddress2 = "";
  selectedState = null;
  zipCode = '';
  lattitude = 0;
  longitude = 0;
  savedLocation;
  invalidData: boolean = false;
  addEditOptionHeader: string = '';
  addNewOptionForm: FormGroup;
  invalidGroupData: boolean = false;
  isDisabled: boolean = false;
  duplicateItem: boolean = false;

  constructor(private fb: FormBuilder, private app: AppMainComponent, private organizationSubscriptionService: OrganizationSubscriptionService,private locationService: LocationsService,private addYear: AddYearPipe,private messageService: MessageService, private titlecasePipe: TitleCasePipe,) { }

  ngOnInit(): void {
      this.locationForm = this.fb.group({
          id: [0],
          organizationId: [""],
          locationId: [
              "",
              [Validators.required, Validators.pattern(/^(?!\s*$).+/)],
          ],
          address: [""],
          name: ["", [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
          description: [""],
          addressId: [0],
          userId: [""],
          phoneNo: ["", Validators.required],
          emailId: ["", [Validators.required, Validators.email]],
          isDefault: [false],
          parentWarehouseId: [0],
          groupId: [""],
          typeId: [""],
          categoryId: [0],
          statusId: [true],
          warehouseProduct: [""],
          warehouseCategory: [""],
      });
      this.addNewOptionForm = this.fb.group({
        id: [0],
        createdSource: [''],
        updatedSource: [''],
        createdBy: [''],
        updatedBy: [''],
        createdDate: [new Date().toISOString()],
        updatedDate: [new Date().toISOString()],
        name: ["", [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
        parentGroupId: [''],
        groupOrganization: [
            {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.userId,
                updatedBy: this.app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                groupId: 0,
                organizationId: this.app.companyId,
                statusId: Status.Active,
            },
        ],
        description: [""],
        isValid: [true],
        validFromDate: [new Date().toISOString()],
        validToDate: [this.addYear.transform(new Date())],
    });
      this.getAllCountry();
      this.getAllAddressTypes();
  }


  ngOnChanges(changes: SimpleChanges): void {
      if (changes.displaylocationView && changes.displaylocationView.currentValue) {
         this.getLocationGroup();
        this.locationForm = this.fb.group({
            id: [0],
            organizationId: [""],
            locationId: [
                "",
                [Validators.required, Validators.pattern(/^(?!\s*$).+/)],
            ],
            address: [""],
            name: ["", [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
            description: [""],
            addressId: [0],
            userId: [""],
            phoneNo: ["", Validators.required],
            emailId: ["", [Validators.required, Validators.email]],
            isDefault: [false],
            parentWarehouseId: [0],
            groupId: [""],
            typeId: [""],
            categoryId: [0],
            statusId: [true],
            warehouseProduct: [""],
            warehouseCategory: [""],
        });
        
      this.locationForm.disable();
      this.view(this.location)
    }
  }



  filterContact(event,action?) {
      const query = event?.query ?? event;
      this.locationService.getAttnContactLost(query?.toLowerCase()).subscribe((res: any) => {
          if (res?.length > 0) {
              this.allContactsDD = res.filter((r) => r.statusId == Status.Active);
              if(action){
                  this.locationForm.controls['userId'].setValue(this.allContactsDD[0])
              }
          }
      
      });
  }

  clearContact(event){
    this.locationForm.controls['userId'].setValue(0);
  }

  
  setDialogProperty(value) {
    this.closeLocationView.emit(value);
    this.display = false;
    this.selectedCountry = null;
    this.selectedState = null;
    this.selectedCity = null;
    this.zipCode = "";
    this.lattitude = 0;
    this.longitude = 0;
    this.addressInput = null;
    this.streetAddress2 = null;
    this.formattedAddress = null;
    this.locationForm.reset();
    this.locationForm.enable();
    this.displayWarehouseView = false;
}

 getLocationGroup() {
    this.loadingSpinner = true;
    this.locationService.getAllGroups().subscribe((groups) => {
        this.inventoryGroups = groups;
        const typeGroup = groups.filter(
            (group) =>
                group.name == ObjectNames.warehouseConstants.typeGroupName
        )[0];
        this.getAllLocationTypes(typeGroup.id);
        this.group = groups.filter(
            (group) => group.name == ObjectNames.warehouseConstants.groupName
        )[0];
        this.getAllLocationGroups(this.group.id);
        this.categoryGroup = groups.filter(
            (group) =>
                group.name ==
                ObjectNames.warehouseConstants.categoryGroupName
        )[0];
        this.getAllLocationCategory(this.categoryGroup.id,this.location?.warehouseCategory);
        this.locationForm.disable();
    this.loadingSpinner = false;
    });
}

getAllLocationTypes(groupId) {
    this.locationService.getAllGroupTypes(groupId).subscribe((types) => {
        this.types = types;
        this.locationForm.controls["typeId"].setValue(this.types[0]);
    });
}

getAllLocationGroups(groupId) {
    this.locationService.getAllGroups(groupId).subscribe((types) => {
        this.groups = types;
        const filteredGroup = this.groups.filter(
            (group) => group.id == this.location.groupId
        )[0];
        this.locationForm.controls["groupId"].setValue(filteredGroup);
    });
}

 getAllLocationCategory(groupId,warehouseCategory) {
     this.locationService.getAllCategory(groupId).subscribe((category) => {
        this.category = category;
        const array = []
             warehouseCategory.forEach((element) => {
          const filter = this.category.filter(
              (cat) => cat.id == element.categoryId
          );
          if (filter.length > 0) {
              array.push(filter[0]);
          }
      });
      this.locationForm.controls["warehouseCategory"].setValue(array);
    });
}

getAllAddressTypes() {
    this.locationService.getAddressTypes().subscribe((types) => {
        this.addressTypes = types;
    });
}

getAllCountry() {
    this.locationService.getCountry().subscribe((country) => {
        this.country = country;
    });
}

getStatesFromCountry(country) {
    const countryID = country.id;
    this.locationService.getAllStates(countryID).then((states) => {
        this.states = states;
    });
}

getCitiesFromState(state) {
    this.locationService.getAllCities(state.id).then((cities) => {
        this.city = cities;
    });
}


async getAsyncStatesFromCountry(country) {
    let countryID = country.id;
    await this.locationService.getAllStates(countryID).then((states) => {
        this.states = states;
        this.selectedState = null;
    });
}

async getAsyncCitiesFromState(state) {
    await this.locationService.getAllCities(state.id).then((cities) => {
        this.city = cities;
        this.selectedCity = null;
    });
}

  async edit(location) {
    this.savedLocation = location;
    this.duplicateItem = false;
    this.locationForm.enable();
    this.selectedCountry = null;
    this.selectedState = null;
    this.selectedCity = null;
    this.zipCode = "";
    this.lattitude = 0;
    this.longitude = 0;
    this.addressInput = '';
    this.formattedAddress = null;
    if (location.address?.country) {
        await this.getAsyncStatesFromCountry(location.address?.country);
    }
    if (location.address?.state) {
        await this.getAsyncCitiesFromState(location.address?.state);
    }
    this.statusDisabled = false;
    this.invalidData = false;
    this.isAddLocation = false;
    if (location.isDefault) {
        this.statusDisabled = true;
    }
    this.locationForm.patchValue(location);
    if(location.contactPersonName){
        this.filterContact(location.contactPersonName,true);
    }
    this.locationForm.controls["statusId"].setValue(
        location.statusId == Status.Active ? true : false
    );
    const filteredType = this.types.filter(
        (type) => type.id == location.typeId
    )[0];
    this.locationForm.controls["typeId"].setValue(filteredType);
    const filteredGroup = this.groups.filter(
        (group) => group.id == location.groupId
    )[0];
    this.locationForm.controls["groupId"].setValue(filteredGroup);
    const array = [];
    location.warehouseCategory.forEach((element) => {
        const filter = this.category.filter(
            (cat) => cat.id == element.categoryId
        );
        if (filter.length > 0) {
            array.push(filter[0]);
        }
    });
    this.locationForm.controls["warehouseCategory"].setValue(array);
    this.formattedAddress = location.address?.streetAddress1;
    this.addressInput = location.address?.streetAddress1;
    this.streetAddress2 = location.address?.streetAddress2;
    const filteredCountry = this.country?.filter(c => c.id == location.address?.countryId)[0];
    this.selectedCountry = filteredCountry;
    const filteredState = this.states?.filter(c => c.id == location.address?.stateId)[0];
    this.selectedState = filteredState;
    const filteredCity = this.city?.filter(c => c.id == location.address?.cityId)[0];
    this.selectedCity = filteredCity;
    this.zipCode = location.address?.zipCode;
    this.displayWarehouseView = false;
    this.display = true;
}
  async view(location) {
    this.loadingSpinner = true;
      this.display =false;
      this.savedLocation = location;
      this.selectedCountry = null;
      this.selectedState = null;
      this.selectedCity = null;
      this.zipCode = "";
      this.lattitude = 0;
      this.longitude = 0;
      this.addressInput = '';
      if (location.address?.country) {
          await this.getAsyncStatesFromCountry(location.address?.country);
      }
      if (location.address?.state) {
          await this.getAsyncCitiesFromState(location.address?.state);
      }
      this.statusDisabled = false;
      this.invalidData = false;
      this.isAddLocation = false;
      if (location.isDefault) {
          this.statusDisabled = true;
      }
      this.locationForm.patchValue(location);
      this.filterContact(location.contactPersonName,true);
      this.locationForm.controls["statusId"].setValue(
          location.statusId == Status.Active ? true : false
      );
      const filteredType = this.types.filter(
          (type) => type.id == location.typeId
      )[0];
      this.locationForm.controls["typeId"].setValue(filteredType);
      const filteredGroup = this.groups.filter(
        (group) => group.id == location.groupId
    )[0];
    this.locationForm.controls["groupId"].setValue(filteredGroup);
    const array = [];
    location.warehouseCategory.forEach((element) => {
        const filter = this.category.filter(
            (cat) => cat.id == element.categoryId
        );
        if (filter.length > 0) {
            array.push(filter[0]);
        }
    });
    this.locationForm.controls["warehouseCategory"].setValue(array);
      this.formattedAddress = location.address?.streetAddress1;
      this.streetAddress2 = location.address?.streetAddress2;
      const filteredCountry = this.country?.filter(c => c.id == location.address?.countryId)[0];
      this.selectedCountry = filteredCountry;
      const filteredState = this.states?.filter(c => c.id == location.address?.stateId)[0];
      this.selectedState = filteredState;
      const filteredCity = this.city?.filter(c => c.id == location.address?.cityId)[0];
      this.selectedCity = filteredCity;
      this.zipCode = location.address?.zipCode;
      this.displayWarehouseView = true;
    this.loadingSpinner = false;
  }
  closeViewDialog(){
    this.displayWarehouseView = false;

  }

  get subscriptionLimitReached(){
    return (this.isAddLocation
    && this.subscriptionLimit?.allowedLicence
    && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
}

saveLocation(value) {
    this.isDisabled = true;
    value.statusId = value.statusId ? Status.Active : Status.InActive;
    value.groupId = value.groupId?.id ?? 0;
    value.typeId = value.typeId?.id ?? 0;
    value.userId = value.userId?.id ?? 0;
    value.organizationId = this.app.companyId;
    const categoryArray = [];
    if (value.warehouseCategory.length > 0) {
        value.warehouseCategory.forEach((element) => {
            const req = {
                id: 0,
                warehouseId: value.id ? value.id : 0,
                statusId: Status.Active,
                categoryId: element.id,
            };
            categoryArray.push(req);
        });
    }
    value.warehouseCategory = [];
    value.warehouseCategory = categoryArray;
    const address = {
        id: (this.savedLocation?.addressId > 0 ? this.savedLocation?.addressId : 0),
        name: this.addressInput,
        streetAddress1: this.formattedAddress,
        streetAddress2: this.streetAddress2,
        description: "",
        latitude: this.lattitude,
        longitude: this.longitude,
        cityId: (this.selectedCity ? this.selectedCity.id : null),
        city: null,
        stateId: (this.selectedState ? this.selectedState.id : null),
        state: null,
        countryId: (this.selectedCountry ? this.selectedCountry.id : null),
        country: null,
        zipCode: this.zipCode,
        addressTypeId: this.addressTypes.filter(
            (a) => a.name == "Billing"
        )[0]?.id,
        statusId: Status.Active,
    };
    value.address = (!this.formattedAddress && !this.selectedCountry && !this.selectedCity && !this.selectedState && !this.zipCode) ? null : address;

    if (this.isAddLocation) {
        const lowerCaseNames = [];
        for (let s of this.allLocations) {
            lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ""));
        }
        if (
            lowerCaseNames.indexOf(
                value.name.toLowerCase().replace(/ /g, "")
            ) > -1
        ) {
            this.invalidData = true;
        } else {
            this.locationService
                .addLocation(value)
                .then(() => {
                    this.isDisabled = false;
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Location added successfully...",
                    });
                    this.checkSubscriptionLimit();
                    this.setDialogProperty(false);
                })
                .catch(() => {
                    this.isDisabled = false;
                    this.setDialogProperty(false);
                });

        }
    } else {
        const duplicateRecord = this.allLocations.find(
            (depOb) =>
                depOb.name.toLowerCase() == value.name.toLowerCase() &&
                depOb.id !== value.id
        );
        if (duplicateRecord) {
            this.invalidData = true;
        } else {
            this.invalidData = false;
            this.updateLocation(value);
        }
    }
  
}

updateLocation(value) {
    this.locationService
        .updateLocation(value)
        .subscribe(() => {
            this.isDisabled = false;
            this.messageService.add({
                severity: Severity.Success,
                summary: this.titlecasePipe.transform(Severity.Success),
                detail: "Location updated successfully...",
            });
            this.setDialogProperty(false);
            this.closeLocationView.emit(true)
        })
}
checkSubscriptionLimit(){
    this.organizationSubscriptionService
    .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Location).subscribe({
        next: (response)=>{
            this.subscriptionLimit = response;
        }
    })
}
checkWarehouseStatus() {
    if (!this.isAddLocation && !this.locationForm.controls['statusId'].value) {
        this.locationService.getWarehouseStatus(this.locationForm.controls['id'].value).subscribe(status => {
            if (status.item1) {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: `${status.item2}`,
                });
                this.locationForm.controls['statusId'].setValue(true);
            }
        })
    }
} 

onAddressBlur(address) {
    this.addressInput = address;
    this.formattedAddress = this.addressInput;
    if (address == '') {
        this.addressInput = '';
        this.formattedAddress='';
        this.streetAddress2 = "";
        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;
        this.zipCode = "";
    }
} 
 
addNewOption(value) {
    this.addEditOptionHeader = ObjectNames.warehouseConstants.AddGroupTitle;
    this.invalidGroupData = false;
    if (value.groupId.name == ObjectNames.warehouseConstants.AddGroupTitle) {
        this.addNewOptionForm = this.fb.group({
            id: [0],
            createdSource: [this.app.userIP],
            updatedSource: [this.app.userIP],
            createdBy: [this.app.userId],
            updatedBy: [this.app.userId],
            createdDate: [new Date().toISOString()],
            updatedDate: [new Date().toISOString()],
            name: [
                "",
                [Validators.required, Validators.pattern(/^(?!\s*$).+/)],
            ],
            parentGroupId: [this.group.id],
            groupOrganization: [
                {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: new Date().toISOString(),
                    updatedDate: new Date().toISOString(),
                    groupId: 0,
                    organizationId: this.app.companyId,
                    statusId: Status.Active,
                },
            ],
            description: [""],
            isValid: [true],
            validFromDate: [new Date().toISOString()],
            validToDate: [this.addYear.transform(new Date())],
        });
        this.displayAddNewOption = true;
    }
}

checkDuplicateLocationId() {
    const locId = (!this.isAddLocation ? this.savedLocation.id : 0);
    const locationId = this.locationForm.controls['locationId'].value;
    if (locationId) {
        this.locationService.checkIsDuplicateLocation(locationId, locId).subscribe(check => {
            if (check) {
                this.duplicateItem = true;
            } else {
                this.duplicateItem = false;
            }
        })
    }
}

removeAddressLocation() {
    this.addressInput = "";
    this.formattedAddress = "";
    this.streetAddress2 = "";
    this.selectedCountry = null;
    this.selectedState = null;
    this.selectedCity = null;
    this.zipCode = "";
}

getAddressObj(address) {
    const addressObj = {
        street_number: null,
        subpremise: null,
        plus_code: null,
        neighborhood: null,
        landmark: null,
        route: null,
        sublocality_level_3: null,
        sublocality_level_2: null,
        sublocality_level_1: null,
        locality: null,
        city: null,
        state: null,
        country: null,
        zipCode: null,
        latitude: address.geometry.location.lat(),
        longitude: address.geometry.location.lng(),
    }
    address.address_components.forEach(comp => {
        const field = comp.types[0];
        if (field == 'street_number') {
            addressObj.street_number = comp;
        }
        if (field == 'plus_code') {
            addressObj.plus_code = comp;
        }
        if (field == 'neighborhood') {
            addressObj.neighborhood = comp;
        }
        if (field == 'landmark') {
            addressObj.landmark = comp;
        }
        if (field == 'route') {
            addressObj.route = comp;
        }
        if (field == 'sublocality_level_3') {
            addressObj.sublocality_level_3 = comp;
        }
        if (field == 'sublocality_level_2') {
            addressObj.sublocality_level_2 = comp;
        }
        if (field == 'sublocality_level_1') {
            addressObj.sublocality_level_1 = comp;
        }
        if (field == 'subpremise') {
            addressObj.subpremise = comp;
        }
        // city
        if (field == 'locality') {
            addressObj.locality = comp;
            addressObj.city = comp;
        }
        // state
        if (field == 'administrative_area_level_1') {
            addressObj.state = comp;
        }

        if (field == 'country') {
            addressObj.country = comp;
        }
        if (field == 'postal_code') {
            addressObj.zipCode = comp;
        }
    });
    if (addressObj.city == null) {
        addressObj.city = addressObj.sublocality_level_1;
    }
    return addressObj;
}

getStreetAddres(googleAddressObj) {
    const street = [];
    if (googleAddressObj.plus_code) {
        street.push(googleAddressObj.plus_code.long_name);
    }
    if (googleAddressObj.street_number) {
        street.push(googleAddressObj.street_number.long_name);
    }
    if (googleAddressObj.route) {
        street.push(googleAddressObj.route.long_name);
    }
    if (googleAddressObj.subpremise) {
        street.push(`#${googleAddressObj.subpremise.long_name}`);
    }
    if (googleAddressObj.neighborhood) {
        street.push(googleAddressObj.neighborhood.long_name);
    }
    if (googleAddressObj.sublocality_level_3) {
        street.push(googleAddressObj.sublocality_level_3.long_name);
    }
    if (googleAddressObj.sublocality_level_2) {
        street.push(googleAddressObj.sublocality_level_2.long_name);
    }
    if (googleAddressObj.sublocality_level_1 && googleAddressObj.locality != null) {
        street.push(googleAddressObj.sublocality_level_1.long_name);
    }

    return street.length ? street.join(' ') : '';
}

async addCity(searchedCityName, stateId) {
    const data = {
        id: 0,
        createdSource: this.app.user.userIP,
        updatedSource: null,
        createdBy: this.app.user.userId,
        updatedBy: 0,
        createdDate: new Date(),
        updatedDate: null,
        name: searchedCityName,
        description: searchedCityName,
        stateId: stateId,
        statusId: 1,
    }
    const newAddedCity = await this.locationService.addCity(data)
    this.city = addInList(this.city, newAddedCity);
    return newAddedCity;
}

async addState(stateDetails, countryId) {
    const data = {
        id: 0,
        createdSource: this.app.user.userIP,
        updatedSource: null,
        createdBy: this.app.user.userId,
        updatedBy: 0,
        createdDate: new Date(),
        updatedDate: null,
        name: stateDetails.long_name,
        shortName: stateDetails.short_name,
        description: stateDetails.long_name,
        countryId: countryId,
        statusId: 1,
    }
    const newAddedState = await this.locationService.addState(data);
    this.states = addInList(this.states, newAddedState);
    return newAddedState;
}

async locationAddresChanged(address: any) {
    this.removeAddressLocation();
    this.ErrorMessageSetLocation = "";
    this.formattedAddress = address.formatted_address;
    const googleAddressObj = this.getAddressObj(address);

    setTimeout(() => {
        const da = this.getStreetAddres(googleAddressObj); 
        this.addressInput = da;
        this.formattedAddress = da;
    });

    this.selectedCountry = null;
    this.selectedState = null;
    this.selectedCity = null;
    this.zipCode = "";
    this.lattitude = googleAddressObj.latitude;
    this.longitude = googleAddressObj.latitude;

    let searchedCountry = googleAddressObj.country ? googleAddressObj.country.long_name : '';
    let searchedZipcode = googleAddressObj.zipCode ? googleAddressObj.zipCode.long_name : '';
    let searchedState = googleAddressObj.state ? googleAddressObj.state.long_name : '';
    let searchedCity = googleAddressObj.city ? googleAddressObj.city.long_name : '';
    if (searchedCountry) {
        let matchedCountry;
        if (searchedCountry == 'USA' || searchedCountry == 'United States') {
            matchedCountry = this.country.find(obj => obj.name == searchedCountry || obj.countryCode == googleAddressObj.country.short_name);
        } else {
            matchedCountry = this.country.find(obj => obj.name == searchedCountry)
        }

        if (matchedCountry) {
            await this.getAsyncStatesFromCountry(matchedCountry);
            this.selectedCountry = matchedCountry;

            //set state
            let matchedState = this.states.find(obj => obj.name == searchedState || obj.shortName == googleAddressObj.state.short_name);
            if (matchedState) {
                this.selectedState = matchedState;
            } else if (!matchedState) {
                // add state
                matchedState = await this.addState(googleAddressObj.state, matchedCountry.id);
                this.selectedState = matchedState;
            }

            await this.getAsyncCitiesFromState(matchedState);

            if (searchedZipcode) {
                this.zipCode = searchedZipcode;
            }
            //set city
            let matchedCity = this.city ? this.city.find(obj => obj.name == searchedCity) : null;
            if (matchedCity) {
                this.selectedCity = matchedCity;
            } else if (!matchedCity) {
                matchedCity = await this.addCity(searchedCity, matchedState.id);
                this.selectedCity = matchedCity;
            }
        }
    }
}

saveGroup(value) {
    value.description = value.name;
    const lowerCaseNames = [];
    for (let s of this.groups) {
        lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ""));
    }
    if (
        lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, "")) >
        -1
    ) {
        this.invalidGroupData = true;
    } else {
        this.locationService
            .addLocationGroup(value)
            .then(() => {
                this.getLocationGroup();
                this.displayAddNewOption = false;
            })
            .catch(() => {
                this.displayAddNewOption = false;
            });
    }
}

}
